/**
 * @generated SignedSource<<350bdf827398aea455dcf85837b36616>>
 * @relayHash 15de772a34fe83bb1653a87290463ad9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 58bbd69cbd8d9463d2d816ffd6d03b71998e011aca2ce83c1fb392842f2056cf

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ItamPermissionsBoundaryTenantContextQuery } from './ItamPermissionsBoundaryTenantContextQuery.graphql';

const node: PreloadableConcreteRequest<ItamPermissionsBoundaryTenantContextQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "58bbd69cbd8d9463d2d816ffd6d03b71998e011aca2ce83c1fb392842f2056cf",
    "metadata": {},
    "name": "ItamPermissionsBoundaryTenantContextQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
